<template>
  <div class="main">
    <date></date>
    <div style="height: 100px"></div>
    <!-- 菜单 -->

    <h2 style="margin: 0; text-align: center">当前小区：雲尚公馆</h2>
    <div class="ppt">
      <el-carousel>
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img style="width: 100%; height: 320px" :src="item.url" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>


    <div v-if="infoShow2" class="card" @click="info2">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[1].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        党建引领标准化小区建设评分<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <div class="header">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        党建引领标准化小区建设评分<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type">

        <Pf/>
      

      </div>
    </div>

    <!-- 基础信息未展开 -->
    <div v-if="infoShow" class="card" @click="info">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[0].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        基础信息<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <div class="header" @click="goto('基础信息')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        基础信息<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('基础信息')">
        <div class="small_box" v-for="(item, index) in menuList[0].type">
          {{ item }}
        </div>
      </div>
    </div>


    <!-- 标准化建设未展开 -->
    <div class="card" @click="starand" v-if="starandShow">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[1].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        标准化建设<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('标准化建设')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('标准化建设')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        1+3+N标准化建设<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('标准化建设')">
        <div class="small_box" v-for="(item, index) in menuList[1].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 公示公开未展开 -->
    <div v-if="publicShow" @click="public" class="card">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[2].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        公示公开<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('公示公开')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('公示公开')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        公示公开<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('公示公开')">
        <div class="small_box" v-for="(item, index) in menuList[2].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 报事报修未展开 -->
    <div v-if="repairShow" @click="repair" class="card">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[3].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        业主诉求<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('报事报修')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('业主诉求')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        业主诉求<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('业主诉求')">
        <div class="small_box" v-for="(item, index) in menuList[3].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 信用信息未展开 -->
    <div v-if="creditShow" @click="credit" class="card">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[4].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        信用信息<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>
    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('信用信息')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('信用信息')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        信用信息<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('信用信息')">
        <div class="small_box" v-for="(item, index) in menuList[4].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 维修资金未展开 -->
    <div class="card" v-if="wxzjShow" @click="wxzj">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[5].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        维修资金<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('维修资金')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('维修资金')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        维修资金<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('维修资金')">
        <div class="small_box" v-for="(item, index) in menuList[5].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 安全管理未展开 -->
    <div v-if="safeShow" @click="safe" class="card">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[6].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        安全管理<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('安全管理')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('安全管理')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        安全管理<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('安全管理')">
        <div class="small_box" v-for="(item, index) in menuList[6].type">
          {{ item }}
        </div>
      </div>
    </div>

    <!-- 装饰装修未展开 -->
    <div class="card" v-if="decorationShow" @click="decoration">
      <div style="height: 50px; margin-top: 20px">
        <img style="width: 53px; height: 56px" :src="menuList[7].url" alt="" />
      </div>
      <div>
        <i style="font-size: 20px" class="el-icon-caret-left"></i>
        装饰装修<i style="font-size: 20px" class="el-icon-caret-right"></i>
      </div>
    </div>

    <div class="show_card" v-else>
      <!-- <img
        class="detail"
        @click="goto('装饰装修')"
        src="../assets/images/detail2x.png"
        alt=""
      /> -->
      <div class="header" @click="goto('装饰装修')">
        <i style="font-size: 20px" class="el-icon-caret-right"></i>
        装饰装修<i style="font-size: 20px" class="el-icon-caret-left"></i>
      </div>
      <div class="type" @click="goto('装饰装修')">
        <div class="small_box" v-for="(item, index) in menuList[7].type">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import url from "../assets/images/ppt.png";
import url22 from "../assets/images/ppt2.jpg";

import url1 from "../assets/images/info@2x.png";
import url2 from "../assets/images/starand.png";
import url3 from "../assets/images/public.png";
import url4 from "../assets/images/repair.png";
import url5 from "../assets/images/imfor.png";
import url6 from "../assets/images/safe.png";
import url7 from "../assets/images/zhuangshi.png";
import url8 from "../assets/images/wxzj.png";
import date from "../components/header/index.vue";


import Pf from "./pf/index.vue";
export default {
  name: "",
  components: { 
    date,
    Pf
   },
  data() {
    return {
      imgList: [
        {
          url: url,
        },
        // {
        //   url: url,
        // },
        // {
        //   url: url22,
        // }
      ],
      menuList: [
        {
          title: "基础信息",
          url: url1,
          type: [
            "住宅户数",
            "建筑面积",
            "小区车位",
            "收费标准",
            "常驻人口",
            "党员人数",
            "学龄前儿童",
            "60岁以上老人",
            "监督举报电话",
          ],
        },
        {
          title: "标准化建设",
          url: url2,
          type: [
            "1+3+N小区治理",
            "四项制度",
            "六有服务",
            "多元评价",
            "评先评优",
          ],
        },
        {
          title: "公示公开",
          url: url3,
          type: [
            "政策文件",
            "服务事项",
            "公共收益",
            "通知公告",
            "投票表决",
            // "监督举报电话",
          ],
        },
        {
          title: "业主诉求",
          url: url4,
          type: [
            "业主诉求流程",
            "业主诉求指南",
            "业主诉求记录",
            "业主诉求处置",
          ],
        },
        {
          title: "信用信息",
          url: url5,
          type: [
            "信用评价标准",
            "物业企业信用信息",
            "物业人员",
            // "业主有效投诉扣分",
          ],
        },
        {
          title: "维修资金",
          url: url7,
          type: [
            "一般使用流程",
            "紧急使用流程",
            "维修资金使用",
            "维修资金分布",
            "使用明细",
            "使用投票",
          ],
        },
        {
          title: "安全管理",
          url: url6,
          type: [
            "制度清单",
            "应急预案",
            "应急演练",
            "巡查巡检",
            "安全隐患",
            "事件上报",
          ],
        },

        {
          title: "装饰装修",
          url: url7,
          type: [
            // "政策文件",
            "办理流程",
            "办事指南",
            "正在装修",
            "装修巡查",
            "装修巡检整改",
          ],
        },
      ],
      infoShow: true,
      infoShow2: true,
      starandShow: true,
      publicShow: true,
      repairShow: true,
      creditShow: true,
      safeShow: true,
      wxzjShow: true,
      decorationShow: true,
    };
  },
  created() { },
  mounted() {
    window.scrollTo(0, 0); // 将页面滚动到顶部
  },
  methods: {
    goto(item) {
      if (item == "基础信息") {
        this.$router.push("/baseInfo");
      } else if (item == "业主诉求") {
        this.$router.push("/repair");
      } else if (item == "标准化建设") {
        this.$router.push("/starand");
      } else if (item == "公示公开") {
        this.$router.push("/public");
      } else if (item == "维修资金") {
        this.$router.push("/wxzj");
      } else if (item == "安全管理") {
        this.$router.push("/safe");
      } else if (item == "装饰装修") {
        this.$router.push("/decoration");
      } else if (item == "信用信息") {
        this.$router.push("/credit");
      }
    },
    info() {
      this.infoShow = !this.infoShow;
      this.infoShow2 = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
    },

    info2() {
      this.infoShow2 = !this.infoShow2;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
    },


    starand() {
      this.starandShow = !this.starandShow;
      this.infoShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    public() {
      this.publicShow = !this.publicShow;
      this.infoShow = true;
      this.starandShow = true;
      this.repairShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    repair() {
      this.repairShow = !this.repairShow;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    credit() {
      this.creditShow = !this.creditShow;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.safeShow = true;
      this.wxzjShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    wxzj() {
      this.wxzjShow = !this.wxzjShow;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.safeShow = true;
      this.creditShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    safe() {
      this.safeShow = !this.safeShow;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.wxzjShow = true;
      this.creditShow = true;
      this.decorationShow = true;
      this.infoShow2 = true;
    },
    decoration() {
      this.decorationShow = !this.decorationShow;
      this.infoShow = true;
      this.starandShow = true;
      this.publicShow = true;
      this.repairShow = true;
      this.wxzjShow = true;
      this.creditShow = true;
      this.safeShow = true;
      this.infoShow2 = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  // width: 1080px;
  height: 2000px;
  background-color: #001742;

  color: #fff;
  overflow: auto;
  padding: 0 100px;
}

.ppt {
  // width: 880px;
  margin: 20px 0 20px 0;
  height: 320px;
  border-radius: 10px 10px 10px;
}

::v-deep .el-carousel {
  border-radius: 10px;
}

.icon {
  width: 53px;
  height: 56px;
}

.menu {
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;

  &:hover {
    font-weight: 600;
  }
}

.card {
  // width: 880px;
  cursor: pointer;
  height: 119px;
  background: linear-gradient(180deg, #003a87 0%, rgba(0, 40, 93, 0) 100%);
  box-shadow: inset 0px 0px 10px 0px rgba(39, 144, 255, 0.78);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #1bd9ff;
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
  color: #8ec8ff;
  font-weight: 700;

  transition: all 0.1s ease;
}

.show_card {
  position: relative;
  cursor: pointer;
  min-height: 107px;
  padding-bottom: 20px;
  background: linear-gradient(180deg, #003a87 0%, rgba(0, 40, 93, 0) 100%);
  box-shadow: inset 0px 0px 10px 0px rgba(39, 144, 255, 0.78);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #2790ff;
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
  color: #8ec8ff;
  font-weight: 700;
  transition: all 0.1s ease;
}

.detail {
  position: absolute;
  right: 0;
  height: 100%;
  width: 30px;
  z-index: 999;
  cursor: pointer;
}

.header {
  margin-top: 20px;
}

.type {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 40px;

  .small_box {
    margin: 20px 0 0 20px;
    padding: 0 10px;
    min-width: 120px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: linear-gradient(180deg, #003a87 0%, rgba(0, 40, 93, 0) 100%);
    box-shadow: inset 0px 0px 10px 0px rgba(39, 144, 255, 0.78);
    border: 1px solid;
    border-image: linear-gradient(180deg,
        rgba(95.00000193715096, 233.00000131130219, 255, 0.6196078658103943),
        rgba(105.00000134110451, 183.00000429153442, 255, 1)) 1 1;
  }
}
</style>
